// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__vPKmi","filesListContainer":"PosDisputesFiles_filesListContainer__3yUk6","filesButton":"PosDisputesFiles_filesButton__3Jzn9"};